import { createContext, useContext } from "react";

export const ShoppingCartContext = createContext({
  cart: [],
  isAddToCard: false,
  addToCart: () => {},
  updateQuantity: () => {},
  clearCart: () => {},
  getTotal: () => {},
  removeFromCart: () => {},
  getQuantity: () => {},
});

export const useShoppingCartContext = () => useContext(ShoppingCartContext);
